import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Admin access token - in production this should be environment variable
const ADMIN_TOKEN = 'f47ac10b-58cc-4372-a567-0e02b2c3d479';

export const useTokenAuth = () => {
  const [searchParams] = useSearchParams();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');
    console.log('Current URL token:', token);
    console.log('Expected token:', ADMIN_TOKEN);
    console.log('Token match:', token === ADMIN_TOKEN);
    setIsAuthenticated(token === ADMIN_TOKEN);
  }, [searchParams]);

  return isAuthenticated;
};
